import { render, staticRenderFns } from "./HowToStartDevelopers.vue?vue&type=template&id=6f65ad88&scoped=true&"
import script from "./HowToStartDevelopers.vue?vue&type=script&lang=js&"
export * from "./HowToStartDevelopers.vue?vue&type=script&lang=js&"
import style0 from "./HowToStartDevelopers.vue?vue&type=style&index=0&id=6f65ad88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65ad88",
  null
  
)

export default component.exports